export default __webpack_public_path__ + "static/media/problem.abcd8164.svg";